/**
 * Polls for a CSS selector to resolve in the DOM, with a timeout. Resolves
 * either way — the caller decides what "still missing" means via showOn or
 * a follow-up check. Used as the body of per-step beforeShowPromise.
 *
 * Replaces the tour-wide pre-flight wait that previously lived in
 * tour-provider.tsx: each step now waits only for its own anchor, at the
 * moment it's about to show, not all-or-nothing at tour start.
 */
export function waitForSelector(
  selector: string,
  opts: { timeoutMs?: number, pollMs?: number } = {},
): Promise<void> {
  const { timeoutMs = 1500, pollMs = 80 } = opts
  if (document.querySelector(selector)) {
    return Promise.resolve()
  }
  return new Promise<void>((resolve) => {
    const start = Date.now()
    const tick = () => {
      if (document.querySelector(selector) || Date.now() - start >= timeoutMs) {
        resolve()
        return
      }
      setTimeout(tick, pollMs)
    }
    setTimeout(tick, pollMs)
  })
}
